export default "__VITE_ASSET__BJkXQwcE__"